import React, { useEffect } from 'react';
import ChatContent from './ChatContent';
import { useNavigate, useParams } from 'react-router-dom';
import { resetGetChatMessages, resetGetChatSingle } from '../../redux/slices/chat.slice';

export default function ChatSinglePage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-1 mt-5 p-1">
      <div className="container relative flex flex-1 flex-col mx-auto max-w-[1163px]">
        {' '}
        <button
          type="button"
          class=" bg-transparent  text-gray-500 font-semibold self-start ml-6 flex items-center gap-2"
          onClick={() => {
            navigate(-1);
          }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="none" stroke="rgb(107, 114, 128)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 12H4m0 0l6-6m-6 6l6 6" />
          </svg>
          Назад
        </button>
        <ChatContent chatId={id} key={id} />
      </div>
    </div>
  );
}
